function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareKeys from './../../../../locales/keys';
import { validateCustomerPin } from '../../../../reducers/actions/customer.actions';
import { VALIDATE_PIN_RESULT } from '../../constants/customer.constants';
var ValidatePinModalComponent = /*#__PURE__*/function () {
  function ValidatePinModalComponent($ngRedux, uiNotificationService) {
    _classCallCheck(this, ValidatePinModalComponent);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerCareKeys: CustomerCareKeys,
      displayValidationFailedMessage: false,
      isLoading: false,
      pin: null,
      formErrors: [i18n.translate(CustomerCareKeys.PROFILE_PAGE.PIN_VALIDATION_ERROR)],
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ValidatePinModalComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget() {
        return {};
      };
      var controllerActions = {
        validateCustomerPin: validateCustomerPin
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onDestory",
    value: function $onDestory() {
      this.disconnectRedux();
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this2 = this;
      if (this.pin) {
        this.isLoading = true;
        this.displayValidationFailedMessage = false;
        this.actions.validateCustomerPin(this.subscriberId, this.pin).then(function (response) {
          if (response.Status === VALIDATE_PIN_RESULT.SUCCESS) {
            _this2.onClose()(true);
          } else {
            _this2.displayValidationFailedMessage = true;
          }
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this2.isLoading = false;
        });
      }
    }
  }]);
}();
export default {
  bindings: {
    subscriberId: '<',
    onClose: '&'
  },
  template: require('./validate.pin.modal.template.html'),
  controller: ValidatePinModalComponent,
  controllerAs: 'pinModal'
};